import { render } from "./footer.vue?vue&type=template&id=46615380"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&lang=stylus"
script.render = render

export default script